'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIllustration from 'UIComponents/image/UIIllustration';
import ContentViewport from '../../../components/ContentViewport';
import ContentControlWrapper from '../../../components/ContentControlWrapper';
import { RequiredProductNames } from '../../../constants/CourseConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UPGRADE_SOURCE_QUERY_PARAM = 'upgradeSource=academy-practical_exercise_required_product';
const PRODUCT_TO_INFO_MAP = {
  [RequiredProductNames.crm]: {
    illustrationName: RequiredProductNames.crm,
    appName: 'browse',
    urlSuffix: `?tab=${RequiredProductNames.crm}&${UPGRADE_SOURCE_QUERY_PARAM}`
  },
  [RequiredProductNames.marketing]: {
    illustrationName: 'marketing-free',
    appName: 'browse',
    urlSuffix: `?tab=${RequiredProductNames.marketing}&${UPGRADE_SOURCE_QUERY_PARAM}`
  },
  [RequiredProductNames.sales]: {
    illustrationName: 'sales-free',
    appName: 'browse',
    urlSuffix: `?tab=${RequiredProductNames.sales}&${UPGRADE_SOURCE_QUERY_PARAM}`
  },
  [RequiredProductNames.paidMarketing]: {
    illustrationName: 'marketing-basic',
    appName: 'browse',
    urlSuffix: `compare/marketing/?product=professional&${UPGRADE_SOURCE_QUERY_PARAM}`
  }
};
const BASE_CLASS_NAME = 'practical-exercise-required-product';
const PracticalExerciseRequiredProduct = ({
  requiredProduct,
  portalId,
  advanceToNextContent,
  onClickProductLink
}) => {
  const productInfo = PRODUCT_TO_INFO_MAP[requiredProduct];
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(ContentViewport, {
      wrapperClassName: BASE_CLASS_NAME,
      children: [/*#__PURE__*/_jsx("h1", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.header`
        })
      }), /*#__PURE__*/_jsx(UIIllustration, {
        name: productInfo.illustrationName
      }), /*#__PURE__*/_jsx("p", {
        className: `${BASE_CLASS_NAME}__description`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.description`
        })
      })]
    }), /*#__PURE__*/_jsx(ContentControlWrapper, {
      children: /*#__PURE__*/_jsxs("div", {
        className: `${BASE_CLASS_NAME}__content-control`,
        children: [/*#__PURE__*/_jsx(UIButton, {
          onClick: advanceToNextContent,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.skip"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          href: `/${productInfo.appName}/${portalId}/${productInfo.urlSuffix}`,
          onClick: onClickProductLink,
          rel: "noopener",
          target: "_blank",
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.button`
          })
        })]
      })
    })]
  });
};
PracticalExerciseRequiredProduct.propTypes = {
  advanceToNextContent: PropTypes.func.isRequired,
  onClickProductLink: PropTypes.func.isRequired,
  portalId: PropTypes.number.isRequired,
  requiredProduct: PropTypes.oneOf(Object.keys(RequiredProductNames)).isRequired
};
export default PracticalExerciseRequiredProduct;